
import ApiClient from '@/services/ApiService'

export const namespaced = true;

export const state = {
  product: null,
  docs: []
}

export const actions = {
  async fetchProduct({ commit }, id) {
    return await ApiClient.getSbDataById(id)
      .then(async (response) => {
        commit('UPD_PRODUCT', await response.data)
        return response.data
      })
  },
  resetProduct({ commit }) {
    commit('UPD_PRODUCT', null)
  },
  async fetchDocsForArt({ commit }, payload) {
    return await ApiClient.getDocsForArt(payload.artnr, payload.lang)
      .then(async (response) => {
        commit('UPD_PRODUCT_DOCS', await response.data)
        return response.data
      })
  },
}
export const mutations = {
  UPD_PRODUCT(state, product) {
    state.product = product
  },
  UPD_PRODUCT_DOCS(state, docs) {
    state.docs = docs
  },
}
export const getters = {
  getProduct: state => state.product,
  getDocs: state => state.docs,
}
